import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/app/src/layout.tsx";
import { Alert } from "@material-ui/lab";
import { ReservationForm } from "../../../components/ReservationForm";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Content = makeShortcode("Content");
const Box = makeShortcode("Box");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Content mdxType="Content">
      <Box mb={4} mdxType="Box"><Alert variant="filled" severity={"success"} icon={false} mdxType="Alert">
          <p>{`Thank you,`}<br />{`
we have received your reservation request.`}<br />{`
We will confirm it shortly by email or phone.`}</p>
          <p>{`If you have any questions or concerns, don’t hesitate to `}<a parentName="p" {...{
              "href": "/en/contact-us/"
            }}>{`contact us`}</a>{`.`}</p>
        </Alert></Box>
      <ReservationForm variant="outlined" mdxType="ReservationForm" />
    </Content>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      